import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_Info = _resolveComponent("Info");
  const _component_b_card_body = _resolveComponent("b-card-body");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_col = _resolveComponent("b-col");
  const _component_Verify = _resolveComponent("Verify");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    id: "subscription-confirm-modal",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.openModal = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    title: $options.isCurrent ? 'Change My Subscription' : 'Choose Subscription',
    "ok-title": $options.isCurrent ? 'Change Subscription' : 'Choose Subscription',
    "ok-variant": "success",
    "ok-disabled": $data.loading || !$data.valid,
    size: "lg",
    onOk: $options.switchSubscription,
    onHidden: $options.closeModal
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: $data.loading
    }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createBlock(_component_b_card, {
      key: 0,
      "no-body": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_card_header, {
        class: "m-0"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("New Subscription Info:", -1)]))], undefined, true),
        _: 1
      }), _createVNode(_component_b_card_body, {
        class: "pt-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_Info, {
          subscriptiontype: $props.subscription.subscriptiontype
        }, null, 8, ["subscriptiontype"])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true), !$data.loading && $props.subscription.billingamount > 0 ? (_openBlock(), _createBlock(_component_b_row, {
      key: 1,
      class: "p-3 text-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "12",
        class: "alert alert-danger mb-1"
      }, {
        default: _withCtx(() => [_createElementVNode("h3", null, " Amount to be charged now: " + _toDisplayString($options.amountDueFormatted), 1)], undefined, true),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "12",
        class: "px-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_Verify, {
          card: $props.subscription.billing,
          open: $props.open,
          onIsValid: $options.setValidity,
          onUpdate: $options.setBillingCvc
        }, null, 8, ["card", "open", "onIsValid", "onUpdate"])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["modelValue", "title", "ok-title", "ok-disabled", "onOk", "onHidden"]);
}